import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const LocationBasicInfoComponent = ({serviceableStatus,warehouses, stores, selectedLocation, handleInnerbasicFormChange, locationType }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Location Type"
            labelField="Text"
            list={locationType}
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'LocationTypeId'
              );
            }}
            optionName='Choose LocationType'
            type="select"
            value={selectedLocation?.LocationTypeId}
            valueField="Value"
        />
    
     { selectedLocation?.LocationTypeId === 10 &&
    
        <InputContainer
            label="StoreName"
            labelField="StoreInfo.StoreName"
            list={stores}
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'LocationId'
              );
            }}
            optionName='Choose Store'
            type="select"
            value={selectedLocation?.LocationId}
            valueField="StoreInfo.Id"
        />
    }
      { selectedLocation?.LocationTypeId === 20 &&
   
        <InputContainer
            label="WarehouseName"
            labelField="WarehouseInfo.WarehouseName"
            list={warehouses}
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'LocationId'
              );
            }}
            optionName='Choose Warehouse'
            type="select"
            value={selectedLocation?.LocationId}
            valueField="WarehouseInfo.Id"
        />
    }
      <InputContainer
            label="Location Name"
            labelField="Location Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'Name'
              );
            }}

            type="text"
            value={selectedLocation?.Name}
        />
         <InputContainer
            label="Serviceable Status"
            labelField="Text"
            list={serviceableStatus}
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'ServiceableStatus'
              );
            }}
            optionName='Choose ServiceableStatus'
            type="select"
            value={selectedLocation?.ServiceableStatus}
            valueField="Text"
        />
        <div className='col-span-full'>
     <InputContainer
            label="Description"
            labelField="Description"
            onValueChange={(event: any, newValue: any) => {
              handleInnerbasicFormChange(
                event.target.value,
                'Description'
              );
            }}

            type="text"
            value={selectedLocation?.Description}
        />
    </div></div>

          }
      expandedPanel="basicInfo"
      headerTitle="Basic Info"
  />
</>
)
export default LocationBasicInfoComponent;
